module.exports = __webpack_public_path__ + "img/Score-Cards_0.3bb46561.png";